<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="添加预约学员" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>添加预约学员</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-autocomplete :items="selectStudentList" v-model="add.book.studentId"
							        item-text="studentName" item-value="id" no-data-text="暂无学员" 
							        label="学员" return-id  dense outlined @change="selectedStudent"></v-autocomplete>
						
						</v-col>
						<v-col cols="12" v-if="add.book.consumeType=='2'">
							<v-text-field label="消课价格" v-model="add.book.recordPrice" dense outlined></v-text-field>
						</v-col>
		
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAdd" :loading="add.submitLoadding" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	
	export default {
		name:"record-book-add-student",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			record:{
				type:Object,
				default:{}
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("record book add student show=",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					// 清空add历史数据
					this.add.book.recordId = this.record.id;
					this.add.book.consumeType = this.record.approveConsumeType;
					//this.add.book.recordPrice = this.record.coursePrice;
					this.add.book.studentId = "";
					this.add.book.recordPrice = "";
					
					
				}
			},
		},
		data(){
			return {
				shopId:"",
				add: {
					dialog: false,
					submitLoadding:false,
					book: {
						recordId:"",
						consumeType:"",
						studentId: "",
						recordPrice: "",
					},
				},
				hideShow:this.show,
				selectStudentList:[]
			}
		},
		mounted() {
			console.log("record book add student mounted");
			
			this.shopId = utils.getCurrentShopId(); 
			this.getStudentListForSelect();
		
		},
		methods:{
			
			cancel(){
				this.$emit("cancel","");
			},
			selectedStudent(){
				
				if (this.add.book.consumeType != "2"){
					return
				}
				
				// 获取价格
				let studentId = this.add.book.studentId;
				let recordId = this.record.id;
				// api
				const that = this;
				let url = `/edu/record/book/student/price/${studentId}/${recordId}`;
			
							
				this.axios.get(url).catch(() => {
					console.log("get price error");
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.add.book.recordPrice = res.data["data"]; 
							return;
						} 
					}
							
				});
			},
			submitAdd() {

				if (!this.add.book.recordId) {
					this.$noty.error('课次ID不能为空');
					return
				}
			
				if (!this.add.book.studentId) {
					this.$noty.error('学员不能为空');
					return
				}
				
				if (this.add.book.consumeType=='2'){
					if (!this.add.book.recordPrice) {
						this.$noty.error('价格不能为空');
						return
					}
				}
				
				
				
				// api
				const that = this;
				let url = `/edu/record/book/student/add`;
				let postData = {
					...this.add.book
				};
			
				
				console.log(postData);
			
				this.add.submitLoadding = true;
			
				this.axios.post(url, postData).catch(() => {
					that.add.submitLoadding = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.add.submitLoadding = false;
							that.$noty.success("添加成功");
							
							that.$emit("success","");
							return;
						} else {
							that.add.submitLoadding = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitLoadding = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			getStudentListForSelect() {
				
				// 获取校区学生列表
				if (!this.shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/student/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectStudentList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			
		}
	}
	
</script>

<style>
</style>
